<div class="modal-header">
  <button type="button" class="close" ng-click="closeApplicationsHistory()">×</button>
  <h4 class="modal-title">Histórico de aplicações da talhão {{historicoAplicacoes[0].gleba.descricao | capitalize}}</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default" ng-repeat="history in historicoAplicacoes" ng-if="historicoAplicacoes.length">
    <div class="panel-heading">
      <h4 class="panel-title">{{history.dt_ini | date:'dd/MM/yyyy'}} à {{history.dt_fim | date:'dd/MM/yyyy'}}</h4>
    </div>
    <div class="panel-body">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Descrição</th>
            <th class="text-right">Dose</th>
            <th class="text-right">Quantidade Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in history.itens track by $index">
            <td class="vertical-middle">{{item.descricao}}</td>
            <td class="text-right">{{item.qt_dose | number:2}} {{item.unidade.abreviatura}} / ha</td>
            <td class="text-right">{{item.qt_total | number:2}} {{item.unidade.abreviatura}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <p class="text-center" ng-if="!historicoAplicacoes.length">Não há aplicações neste talhão.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="closeApplicationsHistory()">Fechar</button>
</div>
